import { LoadingOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import "./index.css";

import { Helmet } from "react-helmet";
import Api from "../../../../apis/Api";
import ServiceApi from "../../../../apis/ServiceApi";
import {
  disableViewTutorial,
  getParamFromUrl,
  getTutorialCode,
  isNullOrEmpty,
  showNotification,
} from "../../../../common";
import ReasonType from "../../../../common/ReasonType";
import SupportStatus from "../../../../common/SupportStatus";
import Titles from "../../../../common/Titles";
import YearPackage from "../../../../common/YearPackage";
import ContactInfo from "./ContactInfo";
import Header from "./Header";
import Footer from "../../../footer";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Prefixs from "common/Prefixs";

const Extend = () => {
  const [loading, setLoading] = useState(false);
  const [isFinish, setIsFinish] = useState(false);
  const [serviceEntityResponse, setServiceEntityResponse] = useState(null);
  const history = useHistory();

  const [form] = Form.useForm();

  useEffect(() => {
    getTutorialCode();
    const dataParam = getParamFromUrl("data");
    if (!isNullOrEmpty(dataParam)) {
      auth(dataParam);
    } else {
      showNotification("error", "Thông báo");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isFinish) {
      disableViewTutorial();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinish]);

  const auth = async (data) => {
    setLoading(true);
    Api.auth(data)
      .then((res) => {
        if (res && res.status === 200 && res.data.data) {
          sessionStorage.setItem("token", res.data.data.jwt);
          history.push(`${Prefixs.COMPENSATION_EXTEND}?requestType=GIA_HAN`);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        showNotification("error", error.response.data.message, "Thông báo");
        setLoading(false);
      });
  };

  const onFinish = async (values) => {
    setLoading(true);

    let request = {
      ...values,
    };

    handleRequest(ServiceApi.extend, 201, request);
  };

  const handleRequest = async (apiFunction, status, ...args) => {
    try {
      const res = await apiFunction(...args);
      if (res && res.status === status && res.data.data) {
        setIsFinish(true);
        setServiceEntityResponse(res.data.data);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataDetail = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.detail(ReasonType.EXTEND);
      console.log("res: ", res);
      if (res && res.status === 200 && res.data.data) {
        // handleDataResponse(res.data.data);
        // history.push(`${Prefixs.COMPENSATION_EXTEND}?requestType=GIA_HAN`);
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const handleDataResponse = (data) => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        phone: data.phone,
        email: data.email,
        duration: data.duration,
      });
      setServiceEntityResponse(data);
      // setIsFinish(data.status === SupportStatus.WAITING);
    }
  };

  return (
    <Spin
      spinning={loading}
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
    </Spin>
  );
};

export default Extend;
